'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var _templateObject;
var css = require('styled-components').css;
var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var sizes = {
  xxxs: {
    fontSize: '1.4rem',
    lineHeight: '2.2rem'
  },
  xxs: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem'
  },
  xs: {
    fontSize: '1.8rem',
    lineHeight: '2.8rem'
  },
  sm: {
    fontSize: '2rem',
    lineHeight: '2.8rem'
  },
  md: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem'
  },
  lg: {
    fontSize: '3.2rem',
    lineHeight: '4rem'
  },
  xl: {
    fontSize: '4rem',
    lineHeight: '5rem'
  },
  xxl: {
    fontSize: '5.0rem',
    lineHeight: '6.2rem'
  },
  xxxl: {
    fontSize: '6.4rem',
    lineHeight: '7.2rem'
  }
};
var sizesMobile = {
  xxxs: {
    fontSize: '1.2rem',
    lineHeight: '1.8rem'
  },
  xxs: {
    fontSize: '1.4rem',
    lineHeight: '2.2rem'
  },
  xs: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem'
  },
  sm: {
    fontSize: '1.8rem',
    lineHeight: '2.8rem'
  },
  md: {
    fontSize: '2rem',
    lineHeight: '2.8rem'
  },
  lg: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem'
  },
  xl: {
    fontSize: '3.2rem',
    lineHeight: '4rem'
  },
  xxl: {
    fontSize: '4rem',
    lineHeight: '5rem'
  },
  xxxl: {
    fontSize: '5rem',
    lineHeight: '6.2rem'
  }
};
var TitleBase = function TitleBase(props) {
  var children = props.children,
    titleLevel = props.titleLevel;
  var sharedStyles = function sharedStyles(props) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: ", ";\n    font-family: ", ";\n    font-weight: normal; // reset browser defaults, weight is applied only though the font-family\n    color: ", ";\n    ", "\n    line-height:  ", ";\n    font-size:  ", ";\n    @media only screen and (min-width: 768px) {\n      line-height: ", ";\n      font-size: ", ";\n    }\n  "])), function (props) {
      return props.margin || 0;
    }, function (_ref) {
      var theme = _ref.theme;
      return getFont(theme, props.weight);
    }, function (props) {
      return colors[props.color];
    }, function (props) {
      return props.center && "text-align: center;";
    }, function (props) {
      return props.forceMobileSize ? sizesMobile[props.forceMobileSize].lineHeight : sizesMobile[props.size].lineHeight;
    }, function (props) {
      return props.forceMobileSize ? sizesMobile[props.forceMobileSize].fontSize : sizesMobile[props.size].fontSize;
    }, function (props) {
      return sizes[props.size].lineHeight;
    }, function (props) {
      return sizes[props.size].fontSize;
    });
  };
  var TitleH1 = styled.h1.withConfig({
    displayName: "TitleBase__TitleH1",
    componentId: "sc-3q2qrq-0"
  })(["", ""], sharedStyles);
  var TitleH2 = styled.h2.withConfig({
    displayName: "TitleBase__TitleH2",
    componentId: "sc-3q2qrq-1"
  })(["", ""], sharedStyles);
  var TitleH3 = styled.h3.withConfig({
    displayName: "TitleBase__TitleH3",
    componentId: "sc-3q2qrq-2"
  })(["", ""], sharedStyles);
  var TitleH4 = styled.h4.withConfig({
    displayName: "TitleBase__TitleH4",
    componentId: "sc-3q2qrq-3"
  })(["", ""], sharedStyles);
  var TitleH5 = styled.h5.withConfig({
    displayName: "TitleBase__TitleH5",
    componentId: "sc-3q2qrq-4"
  })(["", ""], sharedStyles);
  var TitleH6 = styled.h6.withConfig({
    displayName: "TitleBase__TitleH6",
    componentId: "sc-3q2qrq-5"
  })(["", ""], sharedStyles);
  switch (titleLevel) {
    case 'h1':
      return /*#__PURE__*/React.createElement(TitleH1, props, children);
    case 'h2':
      return /*#__PURE__*/React.createElement(TitleH2, props, children);
    case 'h3':
      return /*#__PURE__*/React.createElement(TitleH3, props, children);
    case 'h4':
      return /*#__PURE__*/React.createElement(TitleH4, props, children);
    case 'h5':
      return /*#__PURE__*/React.createElement(TitleH5, props, children);
    case 'h6':
      return /*#__PURE__*/React.createElement(TitleH6, props, children);
  }
};
TitleBase.defaultProps = {
  titleLevel: 'h2',
  size: 'md',
  color: 'BlueDark',
  weight: 'regular',
  center: false,
  forceMobileSize: null
};
var lightAllowed = ['xxxs', 'xxs', 'xs', 'sm', 'md'];
var Title = function Title(props) {
  return /*#__PURE__*/React.createElement(TitleBase, {
    titleLevel: props.level,
    size: props.size,
    weight: props.size === 'xxxl' ? 'extraBold' : props.lightWeight && lightAllowed.includes(props.size) ? 'semiBold' : 'bold',
    color: props.lightColor ? 'White' : 'BlueDark',
    center: props.center,
    className: props.className,
    forceMobileSize: props.forceMobileSize,
    margin: props.margin,
    id: props.id
  }, props.children);
};
Title.defaultProps = {
  size: 'md',
  lightColor: false,
  lightWeight: false,
  center: false,
  forceMobileSize: null
};
exports.Title = Title;